import { Box } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import VesselAdminMasterContent from "../../components/Masters/VesselAdminMaster/VesselAdminMasterContent";
import {
  getScreenAccessMasterList,
  getRoleMasterList,
} from "../../redux/actions/mastersAction";
import RoleMasterContent from "../../components/Masters/RoleMaster/RoleMasterContent";
import ScreenAccessMasterContent from "../../components/Masters/ScreenAccessMaster/ScreenAccessMasterContent";

const ScreenAccessMaster = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getScreenAccessMasterList());
    // dispatch(getRoleMasterList());
  }, []);
  return (
    <>
      <Sidebar activeTab="Masters" title="Masters">
        <Box className="globalContainer_For_Content">
          <ScreenAccessMasterContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default ScreenAccessMaster;
